import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addNotification, loadingApplication } from '@componentDP/js_react/redux/actions/application';
import BasicFormFilePhotoInputWithLabel from './photo';
import {
    changeFilesNotTemporaryStatus, combineUploadFileInfoWithApiFile,
    deleteFileRequest,
    deleteFilesRequest, mapApiFile,
    saveFilesRequest,
} from '@services/filemanager';
import { isEmpty } from 'lodash';
import { filesInfoReceived } from '@componentDP/js_react/redux/actions/files';
import {FilemanagerApi} from '@requests';
import { withTranslation } from 'react-i18next';

class BasicFormFilePhotoContainer extends Component {
    constructor({filesSpr, photoFileId, scanCopySnilsFileId, getPhotoFileIds, successSaveCallback}) {
        super();
        let initFiles = {
            photo: null,
            scan_copy_snils: null,
        };
        if ((photoFileId || scanCopySnilsFileId) && filesSpr) {
            if (photoFileId) {
                const file = filesSpr.find(({id}) => Number(id) === Number(photoFileId));
                if (file) {
                    initFiles.photo = this.mapFileSprToLocalState(file);
                }
            }
            if (scanCopySnilsFileId) {
                const file = filesSpr.find(({id}) => Number(id) === Number(scanCopySnilsFileId));
                if (file) {
                    initFiles.scan_copy_snils = this.mapFileSprToLocalState(file);
                }
            }
        }
        this.state = {
            files: initFiles,
            ids_for_delete: [],
        };
        getPhotoFileIds(this.getFileIds.bind(this));
        successSaveCallback(this.successSaveCallback.bind(this));
    }

    componentDidUpdate () {
        this.props.getPhotoFileIds(this.getFileIds.bind(this));
        this.props.successSaveCallback(this.successSaveCallback.bind(this))
    }

    successSaveCallback = async () => {
        const state = this.state;
        const {apiDomainFilemanager} = this.props;
        const {files} = state;
        const result = {};
        if (files.photo) {
            result.photo = {...files.photo, confirmed: true};
        }
        if (files.scan_copy_snils) {
            result.scan_copy_snils = {...files.scan_copy_snils, confirmed: true};
        }
        const idsForSave = [];
        if (files.photo) {
            idsForSave.push(files.photo.id);
        }
        if (files.scan_copy_snils) {
            idsForSave.push(files.scan_copy_snils.id);
        }
        const promises = [
            changeFilesNotTemporaryStatus(idsForSave, apiDomainFilemanager),
        ];
        if (!isEmpty(state.ids_for_delete)) {
            promises.push(deleteFilesRequest(state.ids_for_delete, apiDomainFilemanager));
        }
        await Promise.all(promises);
        this.setState({...state, ids_for_delete: [], files: result});
    };

    getFileIds = () => {
        const result = {};
        const {files} = this.state;
        if (files.photo) {
            result.photo = files.photo.id;
        }
        if (files.scan_copy_snils) {
            result.scan_copy_snils = files.scan_copy_snils.id;
        }
        return result;
    };

    mapFileSprToLocalState = (file) => {
        return {
            ...mapApiFile(file),
            confirmed: true,
        };
    };

    handleRemoveFile = async (fileKey) => {
        const state = this.state;
        const {loadingApplication} = this.props;
        const {files} = state;
        const file = files[fileKey];
        if (file) {
            const removeFileId = file.id;
            const {files} = state;
            if (!file.confirmed) {
                loadingApplication(true);
                const {apiDomainFilemanager} = this.props;
                const deleteResult = await deleteFileRequest(removeFileId, apiDomainFilemanager);
                if (!deleteResult.hasOwnProperty('error')) {
                    files[fileKey] = null;
                    this.setState({...state, files});
                } else {
                    this.props.addNotification({message: deleteResult.error, type: 'error'});
                }
                loadingApplication(false);
            } else {
                const {ids_for_delete: idsForDelete} = state;
                idsForDelete.push(removeFileId);
                files[fileKey] = null;
                this.setState({...state, ids_for_delete: idsForDelete, files});
            }
        }
    };

    handleDownloadFile = async (fileId) => {
        const {apiDomainFilemanager} = this.props;
        const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
        await filemanagerApi.downloadFile(fileId);
    };

    onDrop = async (acceptedFiles, fileKey) => {
        const {vuzId, apiDomainFilemanager, loadingApplication} = this.props;
        loadingApplication(true);
        const requestsPayload = await saveFilesRequest(acceptedFiles, vuzId, apiDomainFilemanager);
        const state = this.state;
        const files = {...state.files};
        const requestPayload = requestsPayload[0];
        if (requestPayload !== undefined) {
            const {result: requestResult, file} = requestPayload;
            if (!requestResult.hasOwnProperty('error')) {
                this.props.filesInfoReceived([requestResult]);
                const formattedFileInfo = {
                    ...combineUploadFileInfoWithApiFile(requestResult, file),
                    confirmed: false,
                };
                if (files[fileKey]) {
                    const removeFileId = files[fileKey].id;
                    if (!files[fileKey].confirmed) {
                        const deleteResult = await deleteFileRequest(removeFileId, apiDomainFilemanager);
                        if (deleteResult.hasOwnProperty('error')) {
                            this.props.addNotification({message: deleteResult.error, type: 'error'});
                        }
                    } else {
                        const {ids_for_delete: idsForDelete} = state;
                        idsForDelete.push(removeFileId);
                        this.setState({...state, ids_for_delete: idsForDelete});
                    }
                }
                files[fileKey] = formattedFileInfo;
            } else {
                const error = `Файл: ${file.name}:<br>${requestResult.error}`;
                this.props.addNotification({message: error, type: 'error'});
            }
            this.setState({...state, files});
        }
        loadingApplication(false);
    };

    render() {
        const {files} = this.state;
        const { t } = this.props;
        const {digitalProfileSettings} = this.props;
        return (
            <React.Fragment>
                {digitalProfileSettings.is_required_photo
                    ? <BasicFormFilePhotoInputWithLabel file={files.photo}
                                                        label={t('photo')}
                                                        handleRemoveFile={() => this.handleRemoveFile('photo')}
                                                        handleDownloadFile={this.handleDownloadFile}
                                                        onDrop={(acceptedFiles) => this.onDrop(acceptedFiles, 'photo')}
                                                        required/>
                    : null}
                {digitalProfileSettings.is_required_scan_copy_snils
                    ? <BasicFormFilePhotoInputWithLabel file={files.scan_copy_snils}
                                                        label={t('scan_copy_snils')}
                                                        handleRemoveFile={() => this.handleRemoveFile('scan_copy_snils')}
                                                        handleDownloadFile={this.handleDownloadFile}
                                                        onDrop={(acceptedFiles) => this.onDrop(acceptedFiles, 'scan_copy_snils')}
                                                        required/>
                    : null}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        vuzId: state.vuzId,
        filesSpr: state.files,
        apiDomainFilemanager: state.apiDomainFilemanager,
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    addNotification,
    loadingApplication,
    filesInfoReceived,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BasicFormFilePhotoContainer));
